import { WhyChooseUsPage } from "~/components/why-choose-us/WhyChooseUsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/why-choose-us")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/why-choose-us"),
  component: WhyChooseUsPage,
});
